import { render, staticRenderFns } from "./NewBudget.vue?vue&type=template&id=4027c368&"
import script from "./NewBudget.vue?vue&type=script&lang=js&"
export * from "./NewBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewBudget.vue"
export default component.exports